import { render, staticRenderFns } from "./SubNavigation.vue?vue&type=template&id=9f6a0972&scoped=true&"
import script from "./SubNavigation.vue?vue&type=script&lang=js&"
export * from "./SubNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SubNavigation.vue?vue&type=style&index=0&id=9f6a0972&lang=scss&scoped=true&"
import style1 from "./SubNavigation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6a0972",
  null
  
)

export default component.exports